export default __webpack_public_path__ + "static/three-tablets-a7029f0c93241236a49e04b07193cb79.png";